import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Grid, GridUnit } from '@hookdeck/theme/src/Grid';
import { StandardizedInvoice } from '../../../../../../typings/Orb.interface';
import Badge from '../../../../../common/base/Badge';
import Button from '../../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../../common/base/Card';
import Divider from '../../../../../common/base/Divider';
import Link from '../../../../../common/base/Link';
import Loading from '../../../../../common/base/Loading';
import Text from '../../../../../common/base/Text';
import { Div } from '../../../../../common/helpers/StyledUtils';
import useRetryInvoicePayment from './useRetryInvoicePayment';
import { formatDate } from '../../../../../../utils/date';
import { useDatePreferences } from '../../../../../hooks/useDatePreferences';
const PAGE_SIZE = 6;
const usePagination = (items, page_size) => {
  const $ = _c(17);
  const [page, setPage] = useState(1);
  const start = (page - 1) * page_size;
  const end = start + page_size;
  let t0;
  if ($[0] !== end || $[1] !== items || $[2] !== start) {
    t0 = items.slice(start, end);
    $[0] = end;
    $[1] = items;
    $[2] = start;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const page_items = t0;
  let t1;
  if ($[4] !== items.length || $[5] !== page || $[6] !== page_size) {
    t1 = () => {
      if (page < Math.ceil(items.length / page_size)) {
        setPage(page + 1);
      }
    };
    $[4] = items.length;
    $[5] = page;
    $[6] = page_size;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const nextPage = t1;
  let t2;
  if ($[8] !== page) {
    t2 = () => {
      if (page > 1) {
        setPage(page - 1);
      }
    };
    $[8] = page;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const previousPage = t2;
  const t3 = page < Math.ceil(items.length / page_size);
  const t4 = page > 1;
  let t5;
  if ($[10] !== nextPage || $[11] !== page || $[12] !== page_items || $[13] !== previousPage || $[14] !== t3 || $[15] !== t4) {
    t5 = {
      page,
      nextPage,
      hasNextPage: t3,
      previousPage,
      hasPreviousPage: t4,
      items: page_items
    };
    $[10] = nextPage;
    $[11] = page;
    $[12] = page_items;
    $[13] = previousPage;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
export const InvoicesTable = t0 => {
  const $ = _c(41);
  const {
    invoices,
    onRetried
  } = t0;
  const {
    timezone
  } = useDatePreferences();
  const {
    retryInvoicePayment,
    retrying_invoice_id
  } = useRetryInvoicePayment(onRetried);
  let t1;
  if ($[0] !== invoices) {
    t1 = invoices?.filter(_temp).sort(_temp2) || [];
    $[0] = invoices;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const filtered_invoices = t1;
  const {
    nextPage,
    previousPage,
    hasNextPage,
    hasPreviousPage,
    items
  } = usePagination(filtered_invoices, PAGE_SIZE);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      b: 4
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      justify: "space-between"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <GridUnit size={0.3333333333333333}><Div flex={t3}><Text muted={true} semi={true} size="xs" p={{
          x: 4,
          y: 1
        }}>Issue date</Text></Div></GridUnit>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      justify: "space-between"
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <GridUnit size={0.16666666666666666}><Div flex={t5}><Text muted={true} semi={true} size="xs" p={{
          x: 4,
          y: 1
        }}>Amount</Text></Div></GridUnit>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <GridUnit size={0.16666666666666666}><Text muted={true} semi={true} size="xs" p={{
        x: 4,
        y: 1
      }}>Status</Text></GridUnit>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <StyledCardSection muted={true}><Grid>{t4}{t6}{t7}<GridUnit size={0.16666666666666666}><Text muted={true} semi={true} size="xs" p={{
            x: 4,
            y: 1
          }}>Invoice #</Text></GridUnit><GridUnit size={0.16666666666666666} /></Grid></StyledCardSection>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      px: 269
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== filtered_invoices.length || $[11] !== invoices || $[12] !== items || $[13] !== retryInvoicePayment || $[14] !== retrying_invoice_id || $[15] !== timezone) {
    t10 = <StyledCardSection h={t9}>{!invoices ? <Div w={100} h={100} flex={{
        align: "center",
        justify: "center"
      }}><Loading /></Div> : invoices === null || !filtered_invoices?.length ? <Div w={100} h={100} flex={{
        align: "center",
        justify: "center"
      }}><Text muted={true}>No invoices yet.</Text></Div> : <>{items && items.map(invoice_0 => <StyledCardSection key={invoice_0.id}><Grid><GridUnit size={0.3333333333333333}><Div p={{
                x: 4,
                y: 3
              }}><Text base={true} size="s">{formatDate(invoice_0.issue_date, "MMM d, yyyy", timezone)}</Text></Div></GridUnit><GridUnit size={0.16666666666666666}><Div p={{
                x: 4,
                y: 3
              }}><Text base={true} size="s">${(invoice_0.amount_due / 100).toFixed(2)}</Text></Div></GridUnit><GridUnit size={0.16666666666666666}><Div w={100} h={100} p={{
                x: 4
              }} flex={{
                align: "center",
                gap: 2
              }}><Badge success={invoice_0.is_paid} danger={!invoice_0.is_paid} subtle={true}>{invoice_0.is_paid ? "Paid" : invoice_0.payment_failed ? "Payment failed" : "Unpaid"}</Badge>{invoice_0.is_payable && invoice_0.orb_id && <Button.Permission role="admin" ghost={true} small={true} icon="retry" disabled={retrying_invoice_id === invoice_0.orb_id} onClick={() => retryInvoicePayment(invoice_0)} />}</Div></GridUnit><GridUnit size={0.16666666666666666}><Div p={{
                x: 4,
                y: 3
              }}><Text base={true} size="s" ellipsis={true} title={invoice_0.id}>{invoice_0.id}</Text></Div></GridUnit><GridUnit size={0.16666666666666666}><Div p={{
                x: 4,
                y: 3
              }} flex={{
                justify: "flex-end"
              }}><Link href={invoice_0.pdf_url} target="_blank"><Text base={true} size="s">View invoice</Text></Link></Div></GridUnit></Grid></StyledCardSection>)}{items.length < PAGE_SIZE && <Divider />}</>}</StyledCardSection>;
    $[10] = filtered_invoices.length;
    $[11] = invoices;
    $[12] = items;
    $[13] = retryInvoicePayment;
    $[14] = retrying_invoice_id;
    $[15] = timezone;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  let t12;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      x: 4,
      y: 3
    };
    t12 = {
      justify: "space-between"
    };
    $[17] = t11;
    $[18] = t12;
  } else {
    t11 = $[17];
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      align: "center"
    };
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== filtered_invoices.length) {
    t14 = <Text muted={true} semi={true} size="s">{filtered_invoices.length}</Text>;
    $[20] = filtered_invoices.length;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Text muted={true} size="s" m={{
      l: 1
    }}>invoices</Text>;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t14) {
    t16 = <Div flex={t13}>{t14}{t15}</Div>;
    $[23] = t14;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      align: "center",
      gap: 2
    };
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const t18 = !hasPreviousPage;
  let t19;
  if ($[26] !== previousPage || $[27] !== t18) {
    t19 = <Button onClick={previousPage} outline={true} icon="chevron_left" disabled={t18} />;
    $[26] = previousPage;
    $[27] = t18;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  const t20 = !hasNextPage;
  let t21;
  if ($[29] !== nextPage || $[30] !== t20) {
    t21 = <Button onClick={nextPage} outline={true} icon="chevron_right" disabled={t20} />;
    $[29] = nextPage;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] !== t19 || $[33] !== t21) {
    t22 = <Div flex={t17}>{t19}{t21}</Div>;
    $[32] = t19;
    $[33] = t21;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== t16 || $[36] !== t22) {
    t23 = <StyledCardSection><Div p={t11} flex={t12}>{t16}{t22}</Div></StyledCardSection>;
    $[35] = t16;
    $[36] = t22;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== t10 || $[39] !== t23) {
    t24 = <StyledCard m={t2}>{t8}{t10}{t23}</StyledCard>;
    $[38] = t10;
    $[39] = t23;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  return t24;
};
function _temp(invoice) {
  return invoice.amount_due !== 0;
}
function _temp2(a, b) {
  return new Date(a.issue_date).getTime() > new Date(b.issue_date).getTime() ? -1 : 1;
}